module.exports = __webpack_public_path__ + "static/img/JImaging 09.2cecb78e.webp";